import App from './App.svelte';
import 'quill/dist/quill.snow.css';
import 'odometer/themes/odometer-theme-car.css';

const app = new App({
	target: document.body
});

export default app;
